import React, { useState, useEffect, useCallback, useRef } from 'react';
import _ from "lodash";
import * as S from './styles';
import InnerLoader from 'components//InnerLoader';
import { ReactComponent as ExIcon } from 'common/images/search_ex.svg'
import { ReactComponent as SearchIcon } from 'common/images/icon-search-loupe.svg'
import { useDispatch, useSelector } from 'react-redux';
import { OfferInsightsSearchChange } from 'features/Dealers/Performance/state/actions'

export interface IState { }

export interface IProps {
    openMenu?: boolean;
}

const Search: React.FC<IProps> = (props) => {
    const [showClear, setShowClear] = useState(false);
    const [value, setValue] = useState("");
    const [selected, setSelected] = useState(false);
    const [debouncedState, setDebouncedState] = useState("");
    const componentRef = useRef(null);
    const dispatch = useDispatch();

    const handleChange = (event: any) => {
        setValue(event.target.value);

        if(event.target.value.length>0)setShowClear(true);
        else setShowClear(false);

        dispatch(OfferInsightsSearchChange(event.target.value));
    };


    const handleClear = (event: any) => {
        setValue('');
        setShowClear(false);

        if (selected) {
            setSelected(false);
        }
        dispatch(OfferInsightsSearchChange(''));
    }

    return (
        <S.Root ref={componentRef}>
            <SearchIcon style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '27px' }} />
            <S.Col style={{ width: !props.openMenu ? `calc(37vw - 295 + 64)` : `calc(18vw - 64px)` }}>
                <S.InputSearch
                    id="search"
                    placeholder="Search..."
                    value={value}
                    onChange={handleChange}
                    autoComplete="off"
                />
                {   showClear &&
                    <S.Icon onClick={(e) => handleClear(e)}>
                        <ExIcon />
                    </S.Icon>}
            </S.Col>
        </S.Root>
    );
}

export default Search;